import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { TRUSTPILOT_URL } from '~/const/3rd';
export default {
  name: 'TrustPilot',
  mounted: function mounted() {
    this.asyncScript(TRUSTPILOT_URL).then(function () {}).catch(function (err) {
      console.error('TRUSTPILOT_URL FAILED', err);
    });
  }
};